import React, { PropsWithChildren } from 'react'

import { StyledLayout } from './components'

const Layout: React.FC<PropsWithChildren> = ({ children }) => (
  <StyledLayout>{children}</StyledLayout>
)

export { Layout }
